/**
 * Navigation composable with query parameter preservation
 */
export function useNavigationPreservation() {
  const route = useRoute()

  /**
   * Get navigation URL with query parameter preservation
   * @param targetPath - The target path to navigate to
   * @returns Computed navigation URL
   */
  const getNavigationUrl = (targetPath: string) => {
    return computed(() => {
      const hasQueryParams = Object.keys(route.query).length > 0
      const isOnTargetPath = route.path === targetPath

      if (isOnTargetPath && hasQueryParams) {
        return route.fullPath // Preserve current query parameters
      }

      return targetPath // Clean navigation
    })
  }

  return {
    getNavigationUrl,
  }
}
